import React, { useRef } from "react";

export default function StarCircleButton({ onClick, style = {}, title = "Stars" }) {
  const svgRef = useRef();
  return (
    <button
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        background: "#fff",
        boxShadow: "0 2px 12px #8a2be222",
        border: "1.5px solid #cfcfff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 20,
        marginTop: 8,
        cursor: "pointer",
        transition: "box-shadow 0.2s, background 0.2s",
        color: '#000',
        ...style,
      }}
      title={title}
      onClick={onClick}
      onMouseEnter={e => { e.currentTarget.style.background = '#f3eafd'; if (svgRef.current) svgRef.current.style.fill = '#8a2be2'; }}
      onMouseLeave={e => { e.currentTarget.style.background = '#fff'; if (svgRef.current) svgRef.current.style.fill = 'currentColor'; }}
    >
      <svg ref={svgRef} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"/>
      </svg>
    </button>
  );
} 